<div class="upload-container">
  <label>{{ label }}</label>
  <div class="upload-box-wrapper" *ngIf="!isPreview">
    <div
      class="upload-box"
      role="button"
      tabindex="0"
      [class.image-available]="isImageUploaded"
      (keydown)="onKeyDown($event)"
      [style]="uploadedFileImageStyle"
      (click)="onAvatarChange($event)"
    >
      <div class="upload-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#C0CDFC"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="upload-text">{{ 'labels.uploadFile' | translate }}</div>
      <input
        id="file-input-{{ fieldUrlName }}"
        type="file"
        [accept]="allowedFormatFilesView"
        (change)="uploadFile($event)"
        (click)="stopPropagation($event)"
        class="file-input avatar"
      />
    </div>
  </div>
  <div class="upload-box-wrapper preview" *ngIf="isPreview">
    <div class="upload-box preview" [style]="uploadedFileImageStyle"></div>
  </div>
</div>
